import {
  getAuthConnection,
  tokenConnection,
  getNoAuthConnection,
  CognitoTokenConnection,
  logout,
} from "./config";
import { toParams } from "@/utils";

const client_id = process.env.VUE_APP_TOKEN_CLIENT_ID;
const client_secret = process.env.VUE_APP_TOKEN_CLIENT_SECRET;

export function signIn(payload) {
  return tokenConnection.post(
    "token/",
    toParams({
      grant_type: "password",
      client_id: client_id,
      client_secret: client_secret,
      username: payload.username,
      password: payload.password,
    })
  );
}

export function refreshToken(refresh_token) {
  return tokenConnection
    .post(
      "token/",
      toParams({
        grant_type: "refresh_token",
        client_id: client_id,
        client_secret: client_secret,
        refresh_token: refresh_token,
      })
    )
    .catch(() => {
      logout();
    });
}

export function signOut(access_token) {
  return tokenConnection.post(
    "revoke_token/",
    toParams({
      client_id: client_id,
      client_secret: client_secret,
      token: access_token,
    })
  );
}

export function getUserInfo() {
  return getAuthConnection().get(`/userinfo/`);
}

export function getUserLogin() {
  return getAuthConnection().post(`/login/`);
}

export async function getCognitoToken(code) {
  const params = {
    client_id: process.env.VUE_APP_CLIENT_ID,
    redirect_uri: process.env.VUE_APP_REDIRECT_URI.replace("/callback", ""),
    grant_type: "authorization_code",
    code: code,
  };

  return CognitoTokenConnection().post(`/oauth2/token`, params);
}

export function checkTokenAPI(payload) {
  return getNoAuthConnection().post(`/token/check`, payload);
}
